module.exports = __webpack_public_path__ + "static/media/banes.a6d0dc86.png";